import cx from "classnames";

import styles from "./Separator.scss";

interface SeparatorProps {
  separatorPosition: "top" | "bottom";
}

const Separator = ({ separatorPosition }: SeparatorProps) => (
  <div
    className={cx(styles.separator, { [styles.separatorTop]: separatorPosition === "top" })}
    data-testid="separator"
  />
);

export default Separator;
